"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const d3_1 = require("d3");
const react_1 = require("react");
const generateJGraphData_1 = __importDefault(require("../../../data/data1d/Spectrum1D/generateJGraphData"));
const ChartContext_1 = require("../../context/ChartContext");
const useActiveSpectrumRangesViewState_1 = require("../../hooks/useActiveSpectrumRangesViewState");
const usePanelPreferences_1 = require("../../hooks/usePanelPreferences");
const useSpectrum_1 = __importDefault(require("../../hooks/useSpectrum"));
const JGraphContext_1 = require("./JGraphContext");
const JGraphVerticalAxis_1 = require("./JGraphVerticalAxis");
const JsCouplingLinks_1 = __importDefault(require("./JsCouplingLinks"));
const JsCouplings_1 = __importDefault(require("./JsCouplings"));
const marginTop = 50;
function InnerJGraph(props) {
    const { signals, links } = props;
    return ((0, jsx_runtime_1.jsxs)("g", { className: "j-graph", transform: `translate(0,${marginTop})`, children: [(0, jsx_runtime_1.jsx)(JGraphVerticalAxis_1.JGraphVerticalAxis, {}), (0, jsx_runtime_1.jsx)(JsCouplingLinks_1.default, { links: links }), (0, jsx_runtime_1.jsx)(JsCouplings_1.default, { signals: signals })] }));
}
const MemoizedJGraph = (0, react_1.memo)(InnerJGraph);
function JGraph() {
    const { height, view: { spectra: { activeTab }, }, } = (0, ChartContext_1.useChartData)();
    const spectrum = (0, useSpectrum_1.default)();
    const { showJGraph } = (0, useActiveSpectrumRangesViewState_1.useActiveSpectrumRangesViewState)();
    const rangesPreferences = (0, usePanelPreferences_1.usePanelPreferences)('ranges', activeTab);
    const graphHeight = height / 4;
    const { signals, jCouplingMax: maxValue, links, } = (0, react_1.useMemo)(() => (0, generateJGraphData_1.default)(spectrum?.ranges.values, rangesPreferences.jGraphTolerance) || {
        signals: [],
        jCouplingMax: 0,
        links: [],
    }, [rangesPreferences.jGraphTolerance, spectrum?.ranges.values]);
    const scaleY = (0, react_1.useMemo)(() => {
        const maxRange = maxValue + maxValue * 0.1;
        return (0, d3_1.scaleLinear)().range([graphHeight, 0]).domain([0, maxRange]);
    }, [graphHeight, maxValue]);
    const JGraphState = (0, react_1.useMemo)(() => {
        return { scaleY, height: graphHeight, maxValue };
    }, [graphHeight, scaleY, maxValue]);
    if (!showJGraph || !spectrum?.display?.isVisible)
        return null;
    return ((0, jsx_runtime_1.jsx)(JGraphContext_1.JGraphContextProvider, { value: JGraphState, children: (0, jsx_runtime_1.jsx)(MemoizedJGraph, { signals: signals, links: links }) }));
}
exports.default = JGraph;
